import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core'
import { fetchLocusGroupList } from 'reducers/locusGroup/reducer'
import Psfs from 'lib/psfs/Psfs'
import messages from './translate'

class DependentSelectLists extends Component {
  componentDidMount() {
    const { siteValue } = this.props

    this.fetchLocusGroupList(siteValue)
  }

  shouldComponentUpdate(nextProps) {
    const { locusGroupList, setLocusGroups } = this.props
    const { locusGroupList: nextLocusGroupList } = nextProps

    if (locusGroupList !== nextLocusGroupList) {
      setLocusGroups([])
    }

    return true
  }

  fetchLocusGroupList = siteValue => {
    const { fetchLocusGroupList } = this.props

    if (siteValue) {
      const psfs = new Psfs()
      psfs.addFilter('site', siteValue)
      fetchLocusGroupList({ psfs })
    }
  }

  onSiteChange = ({ target: { value } }) => {
    const { setSite } = this.props

    this.fetchLocusGroupList(value)
    setSite(value)
  }

  onLocusGroupChange = ({ target: { value } }) => {
    const { setLocusGroups } = this.props

    setLocusGroups(value)
  }

  render() {
    const {
      siteList,
      siteValue,
      siteError,
      locusGroupsValue,
      locusGroupsError,
      locusGroupList: groupList,
      intl: { formatMessage },
    } = this.props
    const locusGroupList = groupList.toArray()

    return (
      <>
        <FormControl
          fullWidth
          component="div"
          className="form-group"
          error={Boolean(siteError)}>
          <InputLabel required>{formatMessage(messages.site)}</InputLabel>
          <Select
            autoWidth
            value={siteValue}
            onChange={this.onSiteChange}
            MenuProps={{ getContentAnchorEl: null }}>
            {siteList.map(({ id, name }) => (
              <MenuItem button key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
          {Boolean(siteError) && <FormHelperText>{siteError}</FormHelperText>}
        </FormControl>
        <FormControl
          fullWidth
          component="div"
          className="form-group"
          error={Boolean(locusGroupsError)}>
          <InputLabel>{formatMessage(messages.locusGroup)}</InputLabel>
          <Select
            multiple
            disabled={!locusGroupList.length}
            value={locusGroupsValue}
            onChange={this.onLocusGroupChange}
            MenuProps={{ getContentAnchorEl: null }}>
            {locusGroupList.map(({ id, name }) => (
              <MenuItem button key={id} value={id}>
                {name}
              </MenuItem>
            ))}
          </Select>
          {Boolean(locusGroupsError) && (
            <FormHelperText>{locusGroupsError}</FormHelperText>
          )}
        </FormControl>
      </>
    )
  }
}

export default connect(
  state => ({
    locusGroupList: state.getIn(['locusGroup', 'locusGroupList']),
  }),
  {
    fetchLocusGroupList,
  },
)(injectIntl(DependentSelectLists))
